import { Box, Button, Icon, Text } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import type { AppRole, NavSection, NavSectionAction } from "./navConfig";
import { isNavItemActive } from "./navActive";
import { SidebarNavItem } from "./SidebarNavItem";
import { useNavLabel } from "./useNavLabel";
import type { NavBadges } from "./useNavBadges";

interface Props {
  section: NavSection;
  role: AppRole;
  badges: NavBadges;
  onNavigate: (path: string, query?: string) => void;
  onAction: (action: NavSectionAction) => void;
}

export const SidebarSection = ({ section, role, badges, onNavigate, onAction }: Props) => {
  const navLabel = useNavLabel();
  const location = useLocation();

  const visibleItems = section.items.filter((item) => item.roles.includes(role));
  const action = section.action;
  const showAction = action != null && action.roles.includes(role);

  if (visibleItems.length === 0 && !showAction) return null;

  return (
    <Box mb="4">
      <Text px="3" pt="3" pb="1.5" fontSize="11px" fontWeight="semibold" letterSpacing="0.05em" color="smTextDisabled">
        {navLabel(section.titleKey)}
      </Text>

      {visibleItems.map((item) => (
        <SidebarNavItem
          key={`${item.labelKey}-${item.query ?? ""}`}
          item={item}
          isActive={isNavItemActive(item, location.pathname, location.search)}
          badge={item.badgeKey ? badges[item.badgeKey] : undefined}
          onClick={() => onNavigate(item.path, item.query)}
        />
      ))}

      {showAction && action && (
        <Button
          mt="2"
          w="full"
          size="sm"
          colorScheme="teal"
          leftIcon={<Icon as={FiPlus} />}
          onClick={() => onAction(action)}
        >
          {navLabel(action.labelKey)}
        </Button>
      )}
    </Box>
  );
};
